export default __webpack_public_path__ + "static/media/parkingmap5.1e87af72.png";